import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  CLIENT_USER_SESSION_KEY,
  ClientCoreModule,
  ENVIRONMENT,
  HttpInterceptorProviders,
  MatComponentsModule,
  USER_SESSION_TOKEN,
} from '@thehubz/client/core';
import { ApiModule, Configuration } from '@thehubz/client/data-access-api';
import { ClientLoginAndRegistrationModule } from '@thehubz/client/login-and-registration';
import { environment } from '../environments/environment';
import { CustomLayoutModule } from '../lib';
import { AppInitService } from './app-init.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

function initializeApp(appInitService: AppInitService) {
  return (): Promise<void> => {
    return appInitService.init();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatComponentsModule,
    AppRoutingModule,
    ApiModule,
    ClientCoreModule,
    ClientLoginAndRegistrationModule.forRoot({ enableSingUp: false }),
    CustomLayoutModule,
  ],
  providers: [
    AppInitService,
    { provide: ENVIRONMENT, useValue: environment },
    { provide: USER_SESSION_TOKEN, useValue: CLIENT_USER_SESSION_KEY },
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: environment.apiBasePath,
        }),
      multi: false,
    },
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true },
    HttpInterceptorProviders,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
